
        var result = require("!!../../../../node_modules/css-loader/index.js!./treatment-combination.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/treatment-combination.component.css
// module id = 2340
// module chunks = 1